var _path, _line, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLunch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00049 4.83868C11.365 4.83868 13.0237 5.49966 14.1128 6.82697C15.1522 8.09371 15.7558 10.0644 15.8286 12.9324H2.17334C2.24616 10.0646 2.8489 8.09372 3.88818 6.82697C4.97723 5.49969 6.6361 4.83872 9.00049 4.83868Z",
    stroke: "#191919",
    strokeWidth: 1.2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1.56519,
    y1: 15.9,
    x2: 16.4347,
    y2: 15.9,
    stroke: "#191919",
    strokeWidth: 1.2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 7.5,
    y1: 1.65,
    x2: 10.5,
    y2: 1.65,
    stroke: "#191919",
    strokeWidth: 1.2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 9.07485,
    y1: 2.25,
    x2: 9.07485,
    y2: 4.72826,
    stroke: "#191919",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLunch);
export default __webpack_public_path__ + "static/media/lunch.ea91ba588028cff7cf942c229753c2f5.svg";
export { ForwardRef as ReactComponent };